import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import type { FC } from "react";

import { DeltaPill, type DeltaTone } from "./deltaPill.js";

const cardClassName =
  "rounded-md bg-white px-4 pb-4 pt-3 shadow-sm ring-1 ring-black/5";

interface MetricCardProps {
  readonly label: string;
  readonly value: string;
  readonly delta: string;
  readonly deltaTone: DeltaTone;
  readonly comparison: string;
}

export const MetricCard: FC<MetricCardProps> = ({
  label,
  value,
  delta,
  deltaTone,
  comparison,
}) => (
  <div className={cardClassName}>
    <div className="flex items-center justify-between">
      <Label size={Size.SMALL}>{label}</Label>
      <DeltaPill delta={delta} tone={deltaTone} />
    </div>
    <div className="mt-3 text-3xl font-semibold text-foreground">{value}</div>
    <p className="mt-1 text-xs text-muted-foreground">{comparison}</p>
  </div>
);
